/**
 * Language definitions for SchoolConnect Hub
 * Phase 1: English, Afrikaans, isiZulu, isiXhosa
 */

export const languages = [
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: '🇿🇦',
    isRTL: false
  },
  {
    code: 'af',
    name: 'Afrikaans',
    nativeName: 'Afrikaans',
    flag: '🇿🇦',
    isRTL: false
  },
  {
    code: 'zu',
    name: 'isiZulu',
    nativeName: 'isiZulu',
    flag: '🇿🇦',
    isRTL: false
  },
  {
    code: 'xh',
    name: 'isiXhosa',
    nativeName: 'isiXhosa',
    flag: '🇿🇦',
    isRTL: false
  }
]

export const supportedLanguageCodes = languages.map(lang => lang.code)

export const isSupportedLanguage = (code) => {
  return supportedLanguageCodes.includes(code)
}

export const getLanguageByCode = (code) => {
  return languages.find(lang => lang.code === code) || languages[0]
}

export const getDefaultLanguage = () => languages[0]
